/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  Text,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { SupplementalDisclosureData } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function SupplementalDisclosureDataUpdateForm(props) {
  const {
    id: idProp,
    supplementalDisclosureData: supplementalDisclosureDataModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    SupplementalDataSetName: "",
    SupplementalDataSetDescription: "",
  };
  const [SupplementalDataSetName, setSupplementalDataSetName] = React.useState(
    initialValues.SupplementalDataSetName
  );
  const [SupplementalDataSetDescription, setSupplementalDataSetDescription] =
    React.useState(initialValues.SupplementalDataSetDescription);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = supplementalDisclosureDataRecord
      ? { ...initialValues, ...supplementalDisclosureDataRecord }
      : initialValues;
    setSupplementalDataSetName(cleanValues.SupplementalDataSetName);
    setSupplementalDataSetDescription(
      cleanValues.SupplementalDataSetDescription
    );
    setErrors({});
  };
  const [
    supplementalDisclosureDataRecord,
    setSupplementalDisclosureDataRecord,
  ] = React.useState(supplementalDisclosureDataModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? await DataStore.query(SupplementalDisclosureData, idProp)
        : supplementalDisclosureDataModelProp;
      setSupplementalDisclosureDataRecord(record);
    };
    queryData();
  }, [idProp, supplementalDisclosureDataModelProp]);
  React.useEffect(resetStateValues, [supplementalDisclosureDataRecord]);
  const validations = {
    SupplementalDataSetName: [],
    SupplementalDataSetDescription: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          SupplementalDataSetName,
          SupplementalDataSetDescription,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(
            SupplementalDisclosureData.copyOf(
              supplementalDisclosureDataRecord,
              (updated) => {
                Object.assign(updated, modelFields);
              }
            )
          );
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "SupplementalDisclosureDataUpdateForm")}
      {...rest}
    >
      <Heading
        level={4}
        children="Supplemental Disclosure Data"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Heading
        children="NZCS3 Paragraphs 43-46."
        {...getOverrideProps(overrides, "SectionalElement4")}
      ></Heading>
      <Text
        children="Update this record that describes additional data covering changes in disclosures from the previous to current reporting period, and adoption provisions used in this disclosure."
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Divider>
      <TextField
        label="Supplemental disclosure record name (e.g. 2025 supplemental disclosure records)"
        isRequired={false}
        isReadOnly={false}
        value={SupplementalDataSetName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              SupplementalDataSetName: value,
              SupplementalDataSetDescription,
            };
            const result = onChange(modelFields);
            value = result?.SupplementalDataSetName ?? value;
          }
          if (errors.SupplementalDataSetName?.hasError) {
            runValidationTasks("SupplementalDataSetName", value);
          }
          setSupplementalDataSetName(value);
        }}
        onBlur={() =>
          runValidationTasks("SupplementalDataSetName", SupplementalDataSetName)
        }
        errorMessage={errors.SupplementalDataSetName?.errorMessage}
        hasError={errors.SupplementalDataSetName?.hasError}
        {...getOverrideProps(overrides, "SupplementalDataSetName")}
      ></TextField>
      <TextAreaField
        label="Description of supplemental disclosure record (e.g. set of additional disclosure records for the 2025 reporting period)"
        isRequired={false}
        isReadOnly={false}
        value={SupplementalDataSetDescription}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              SupplementalDataSetName,
              SupplementalDataSetDescription: value,
            };
            const result = onChange(modelFields);
            value = result?.SupplementalDataSetDescription ?? value;
          }
          if (errors.SupplementalDataSetDescription?.hasError) {
            runValidationTasks("SupplementalDataSetDescription", value);
          }
          setSupplementalDataSetDescription(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "SupplementalDataSetDescription",
            SupplementalDataSetDescription
          )
        }
        errorMessage={errors.SupplementalDataSetDescription?.errorMessage}
        hasError={errors.SupplementalDataSetDescription?.hasError}
        {...getOverrideProps(overrides, "SupplementalDataSetDescription")}
      ></TextAreaField>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Divider>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || supplementalDisclosureDataModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || supplementalDisclosureDataModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
